import React, { useState } from "react";
import styled from "styled-components";

const PasswordToggleStyles = styled.span`
  margin-top: 0.4rem;
  font-size: 1.2rem;
  cursor: pointer;
  color: #d97706;
  transition: opacity 300ms ease-in-out;

  &:hover {
    opacity: 0.8;
  }
  &:first-letter {
    text-transform: uppercase;
  }
`;

export default function PasswordToggle({
  password,
  showPassword,
  setShowPassword,
}) {
  const toggle = () => {
    setShowPassword(!showPassword);
  };

  return (
    <PasswordToggleStyles onClick={toggle}>
      {password?.length > 0 && (
        <>
          {showPassword && "esconder senha"}
          {!showPassword && "mostrar senha"}
        </>
      )}
    </PasswordToggleStyles>
  );
}
